var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('ImportOrderForm',{on:{"importedFile":_vm.importedFile,"upload":_vm.clearWorkData}}),_c('BjiOrderWorkList',{ref:"WorkList",staticClass:"mt-4",on:{"commitedFile":_vm.commitedFile}}),_c('BjiOrderCommitResult',{ref:"CommitList"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }